import { render } from "./index.vue?vue&type=template&id=21b3f1d6"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=21b3f1d6&lang=scss"

import exportComponent from "/Users/mingyanglezhao/silva/workSP/yemei-font/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__